<template>
    <div class="p-4">
        <div class="d-flex justify-content-between mb-3 align-middle">
            <h2>Gestion des Rôles</h2>
            <a class="btn btn-primary align-middle" v-bind:href="conf.server + `/create-role`">Créer un rôle</a>
        </div>
        <table class="table table-striped mt-2">
            <thead>
                <tr>
                    <th>Nom</th>
                    <th>Description</th>
                    <th>#</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="group in groups" v-bind:key="group">      
                    <td>{{ group.cn }}</td>
                    <td>{{ group.description }}</td>
                    <td><a v-bind:href="`/role/` +  group.cn + `/details`" class="btn btn-light">Voir</a></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import conf from '../../../../config/api.js'

export default {
    data() {
        return {
            conf: conf,
            groups: []
        }
    },
    beforeMount() {
        this.axios.get(`${conf.server}/api/ldap/group/all`) // On fait une requête axios en GET vers l'API afin de récupérer tous les groupes
        .then(res => {
            this.groups = res.data.data // On stocke les groupes dans la variable groups
        })
    }

}
</script>